module.exports = __webpack_public_path__ + "img/6fc9d33.jpg";